import { Outlet, useLocation } from 'react-router-dom';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const Users = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.USERS && location.pathname !== ROUTE_PATHS.USER_CREATE && <BackButton />}
      <Outlet />
    </section>
  );
};

export default Users;
